/**
 * GoalsActiveState - Operational tracking view when at least one goal is active.
 * Shows filters, strategy summary, progress, and builder.
 */
function GoalsActiveState({ children }) {
  return <div className="goalsActiveState">{children}</div>
}

export default GoalsActiveState
